import Button from "../../../common/button";
import { focusSearchField } from "../../../common/header";

export default function StartFollowing() {
  return (
    <div className="flex flex-grow  justify-center bg-gray">
      <div className="relative flex w-full max-w-md flex-col items-center px-4 py-4 text-center">
        <img
          src={"/assets/empty-feed-icon.png"}
          alt="notification"
          className=" flex h-52 w-52 items-center justify-center"
        />

        {/* Main Content */}
        <h1 className="mb-3  text-[32px] font-bold tracking-tight text-gray-900">
          Start Following
        </h1>

        <p className="mb-3 max-w-md text-[20px] leading-relaxed text-gray-500">
          Your feed is empty—find and follow like minded people around you to
          stay ahead in the world of finance!
        </p>

        <Button
          customClasses={`w-full px-[60px] py-3 rounded-xl cursor-pointer `}
          onClick={focusSearchField}
        >
          <span className="text-[18px]">Find Members</span>
        </Button>
      </div>
    </div>
  );
}
